import React, { useEffect } from 'react'
import { Steps } from 'intro.js-react'
import { useDispatch, useSelector } from 'react-redux'
import { PropTypes } from 'prop-types'
import { Box } from '@mui/material'
import 'intro.js/introjs.css'
import './Mapview/MapView.scss'
import { setStartAppTour } from '../slices/tourSlice'
import { setDrawerOpen } from '../slices/mainTool'

export default function CustomAppTour() {
  const { startTour } = useSelector((state) => state.tourSlice)
  const { mapLoaded } = useSelector((state) => state.appSlice)
  const dispatch = useDispatch()

  useEffect(() => {
    if (startTour) {
      dispatch(setDrawerOpen(false))
    }
  }, [startTour])

  const stepsContent = [
    {
      title: 'Setup Project Manually',
      text: 'To begin setting up your project manually, simply click here. This method allows you to bypass selecting a street from the map and instead enter all project details manually.'
    },
    {
      title: 'Search for a Street',
      text: 'Already have a street in mind? Search by address to quickly find your project.'
    },
    {
      title: 'Change the Basemap',
      text: 'Get a different view of your area by changing your basemap.'
    },
    {
      title: 'Map Legend',
      text: 'See what the layers on the map represent by viewing the legend.'
    },
    {
      title: 'Segment Selection Toolbox',
      text: 'Add road segments to your project. You can also use this toolbox to remove segments or start over. Note that the Land Use Context layer needs to be turned on to use the Segment Selection Toolbox.'
    },
    {
      title: 'Land Use Context and Modal Networks',
      text: 'See the types of land uses along your project, and view the networks for people walking, biking, driving, riding transit, and moving freight. Click the boxes to view or hide layers. Layers that are visible have blue boxes.'
    },
    {
      title: 'Take the Tour Again',
      text: 'Click this button to take the tour again.'
    }
  ]
  const steps = [
    {
      intro: <TourBody stepsContent={stepsContent[5]} />,
      position: 'bottom',
      tooltipClass: 'myTooltipClass',
      highlightClass: 'myHighlightClass',
      element: '.layerSelector'
    },
    {
      intro: <TourBody stepsContent={stepsContent[0]} />,
      position: 'bottom',
      tooltipClass: 'myTooltipClass',
      highlightClass: 'myHighlightClass',
      element: '.manualProjectSetup'
    },
    {
      // title:
      //   '<div style="display:flex;align-self:center"><input type="checkbox" id="donotshow" > <label for="donotshow" style="font-size:13px;color:#5C5C5C">Do Not Show Again</label></div>',
      intro: <TourBody stepsContent={stepsContent[1]} />,
      position: 'bottom',
      tooltipClass: 'myTooltipClass',
      highlightClass: 'myHighlightClass',
      element: '.searchBar'
    },
    {
      // title:
      //   '<div style="display:flex;align-self:center"><input type="checkbox" id="donotshow" > <label for="donotshow" style="font-size:13px;color:#5C5C5C">Do Not Show Again</label></div>',
      intro: <TourBody stepsContent={stepsContent[2]} />,
      position: 'bottom',
      tooltipClass: 'myTooltipClass',
      highlightClass: 'myHighlightClass',
      element: '.basemapWidget'
    },
    {
      // title:
      //   '<div style="display:flex;align-self:center"><input type="checkbox" id="donotshow" > <label for="donotshow" style="font-size:13px;color:#5C5C5C">Do Not Show Again</label></div>',
      intro: <TourBody stepsContent={stepsContent[3]} />,
      position: 'bottom',
      tooltipClass: 'myTooltipClass',
      highlightClass: 'myHighlightClass',
      element: '.legendWidget'
    },
    {
      intro: <TourBody stepsContent={stepsContent[4]} />,
      position: 'bottom',
      tooltipClass: 'myTooltipClass',
      highlightClass: 'myHighlightClass',
      element: '.segmentSelectToolbox'
    },

    {
      // title:
      //   '<div style="display:flex;align-self:center"><input type="checkbox" id="donotshow" > <label for="donotshow" style="font-size:13px;color:#5C5C5C">Do Not Show Again</label></div>',
      intro: <TourBody stepsContent={stepsContent[6]} />,
      position: 'bottom',
      tooltipClass: 'myTooltipClass',
      highlightClass: 'myHighlightClass',
      element: '.tourApp'
    }
  ]
  if (!mapLoaded) {
    return
  }

  return (
    <Steps
      enabled={startTour}
      steps={steps}
      initialStep={0}
      onExit={() => {
        dispatch(setStartAppTour(false))
      }}
      options={{ showStepNumbers: true, hidePrev: true }}
    />
  )
}

function TourBody({ stepsContent }) {
  return (
    <Box>
      {/* <div
        style={{
          display: 'flex',
          gap: '16px',
          justifyContent: 'flex-end',
          padding: '10px'
        }}
      >
        <div style={{ display: 'flex', gap: '6px' }}>
          <input
            type="checkbox"
            id="donotshow"
            onChange={() => {
              setChecked(!checked)
            }}
            checked={checked}
          />{' '}
          <label
            for="donotshow"
            style={{ color: '#5C5C5C', alignSelf: 'center' }}
          >
            Do Not Show Again
          </label>
        </div>
        <button
          style={{ backgroundColor: 'transparent', border: 'none' }}
          onClick={() => {
            console.log('clicked')
            setChecked(!checked)
          }}
        >
          <CloseIcon
            onClick={() => {
              console.log('clicked')
            }}
          />
        </button>
      </div> */}
      <div style={{ padding: '20px' }}>
        <h2 style={{ margin: '0px' }}>{stepsContent.title}</h2>
        <p style={{ color: '#5C5C5C', lineHeight: 1.5 }}>{stepsContent.text}</p>
      </div>

      {/* <div
        style={{
          backgroundColor: '#e4e7eb',
          display: 'flex',
          justifyContent: 'space-between',
          height: '40px',
          padding: '10px'
        }}
      >
        <p
          style={{ color: '#3E5E85', fontWeight: 500, paddingLeft: '15px' }}
        >{`Step 1 of 3`}</p>
        <button
          style={{
            outline: 'none',
            border: 'none',
            backgroundColor: themeConfig.semcogGreen,
            padding: '10px',
            color: 'white',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
          id="nextBtn"
        >
          Next
        </button>
      </div> */}
    </Box>
  )
}
TourBody.propTypes = {
  stepsContent: PropTypes.object.isRequired
}
